import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'

class OfferSourcingService {
  constructor() {
    this.resource = API_RESOURCE.OFFER
  }

  splitCostBudget = async ({ offerId, costBudgetIndex, ...data }) => {
    const response = await axios.post(`${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/split`, data)
    return response.data
  }
}
export default OfferSourcingService
